import type { Quiz, QuizProgress } from '@/types/quiz'

type QuizAnswerEntry = {
  right_answer?: boolean
  quiz_question_id?: number
}

export const getQuizScoreLabel = (
  quiz: Quiz,
  progress?: QuizProgress
): string | null => {
  if (!progress) return null

  const answers = progress.answeres as unknown
  const total =
    quiz.max_questions ||
    quiz.quiz_questions?.length ||
    (Array.isArray(answers) ? answers.length : 0)

  if (!total) return null

  if (Array.isArray(answers) && answers.length > 0) {
    const first = answers[0]
    if (first && typeof first === 'object' && 'right_answer' in first) {
      const correct = (answers as QuizAnswerEntry[]).filter(
        entry => entry.right_answer
      ).length
      return `${correct}/${total} acertos`
    }
  }

  if (progress.finished_percent >= 0) {
    const correct = Math.round((progress.finished_percent / 100) * total)
    return `${correct}/${total} acertos`
  }

  return null
}
